export default __webpack_public_path__ + "static/media/tele.c959d854.png";